<template>
    <div class="main-info">
        <div class="main-info-left">
            <p class="main-info-title">
                场地详情
            </p>
            <div class="main-info-field">
                <span class="main-info-txt">场地：</span>
                <span class="main-info-text">{{selectedMeasure.measureName}}</span>
            </div>
            <div class="main-info-address">
                <span class="main-info-txt">地址：</span>
                <span class="main-info-text">{{selectedMeasure.place}}</span>
            </div>
        </div>
        <div class="main-info-right">
            <div class="all">
                <span class="main-info-stxt">{{allData}}</span>
                <span class="main-info-stext">总电量(kWh)</span>
            </div>
            <div class="tb">
                <span class="main-info-stxt">{{tbData}}</span>
                <span class="main-info-stext">同比</span>
            </div>
            <div class="hb">
                <span class="main-info-stxt">{{hbData}}</span>
                <span class="main-info-stext">环比</span>
            </div>
        </div>
    </div>
</template>

<script>
    import dateTool from "@/utils/dateTool"
    export default {
        name:"field",
        props:{
            selectedMeasure:{
                type:Object,
                default:{
                    measureId: "",
                    measureName: ""
                }
            },
            timeElem:{
                type:Object,
                default:()=>{}
            }
        },
        data() {
            return {
                allData:"-",
                tbData:"-",
                hbData:"-"
            }
        },
        methods:{
            async getData(){
                let {tqStartTime,tqEbdTime,hqStartTime,hqEndTime} = {
                    tqStartTime:dateTool.getCheckBeforeTime(this.timeElem.startTime,this.timeElem.endTime,this.timeElem.dateType).startTime,
                    tqEbdTime:dateTool.getCheckBeforeTime(this.timeElem.startTime,this.timeElem.endTime,this.timeElem.dateType).endTime,
                    hqStartTime:dateTool.getCheckRepeatTime(this.timeElem.startTime,this.timeElem.dateType).fromDate,
                    hqEndTime:dateTool.getCheckRepeatTime(this.timeElem.startTime,this.timeElem.dateType).toDate
                };//同期开始结束时间与环期开始结束时间
                let axiosArr = [
                    this.$api.quantity.getQuantity(this.selectedMeasure.measureId,this.timeElem.startTime,this.timeElem.endTime,"100229","0"),//本期
                    this.$api.quantity.getQuantity(this.selectedMeasure.measureId,tqStartTime,tqEbdTime,"100229","0"),//同期
                    this.$api.quantity.getQuantity(this.selectedMeasure.measureId,hqStartTime,hqEndTime,"100229","0")//环期
                ];
                let result = await Promise.all(axiosArr);//得到数据源
                this.allData = (result[0].data ?? "-") == "-" ? "-" : Number(result[0].data).toFixed(2) * 1;
                if((result[1].data ?? "-") == "-" || this.allData == "-"){
                    this.tbData = "-";
                }else if(this.tbData == "0"){
                    this.tbData = "0";
                }else{
                    this.tbData = ((this.allData - result[1].data) / result[1].data).toFixed(4) * 100 + "%";
                }
                if((result[2].data ?? "-") == "-" || this.allData == "-"){
                    this.hbData = "-";
                }else if(this.hbData == "0"){
                    this.hbData = "0";
                }else{
                    this.hbData = ((this.allData - result[2].data) / result[2].data).toFixed(4) * 100 + "%";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-info{
        background: #fff;width: 100%;border-radius: 4px;box-sizing: border-box;overflow: hidden;padding: 10px;text-align: left;color: #333;display: flex;
        .main-info-left{
            height: 100%;width:50%;border-right:1px solid #eee;padding-right:5px;box-sizing:border-box;
            .main-info-field{
                overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-left: 28px;
                .main-info-txt{
                    color: #ccc;height:30px;line-height:30px;
                }
            }
            .main-info-address{
                overflow: hidden;display:flex;margin-left: 28px;
                .main-info-txt{
                    color: #ccc;height:30px;line-height:30px;display: inline-block;width: 42px;
                }
                .main-info-text{
                    flex:1;white-space: normal;line-height:30px;
                }
            }
        }
        .main-info-right{
            height: auto;width:50%;display:flex;padding:10px;box-sizing:border-box;
            .all{
                flex:1;height: 100%;border-radius: 4px;overflow: hidden;background: #5198E7;margin-right: 10px;display: flex;flex-flow: column;align-items: center;justify-content: center;
            }
            .tb{
                flex:1;height: 100%;border-radius: 4px;overflow: hidden;background: #E7927D;margin-right: 10px;display: flex;flex-flow: column;align-items: center;justify-content: center;
            }
            .hb{
                flex:1;height: 100%;border-radius: 4px;overflow: hidden;background: #6BC9B8;display: flex;flex-flow: column;align-items: center;justify-content: center;
            }
            .main-info-stxt{
                color:#fff;font-size: 20px;font-weight: bold;
            }
            .main-info-stext{
                color:#fff;
            }
        }
    }
</style>